import { checkMonTokenTs } from '@helpers/monetizationUtils.js'
import { MONETIZATION_BASE_URL } from '@config'
import { queryString } from '@helpers/utils.js'
import { GAME_ID } from '@config/game.js'
import { createClient } from '@services'
import qs from 'qs'

const { get, post } = createClient()

/* API request to get a ui session from the api used for tilia widget */
export async function getSessionRequest() {
  const { data } = await post('/widgets/tilia', null, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  return data
}

/* API request to register a user for onboarding via the api */
export async function registerRequest() {
  const { data } = await post('/me/register', null, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  return data
}

/* API request to get a ui authentication from the api used to interact with monetization api */
export async function getAuthenticateRequest() {
  const { data } = await post('/me/authenticate', null, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  return data
}

/* API request to checkout marketplace via the api */
export async function checkoutRequest(update) {
  const { data } = await post('/cogs/checkout', qs.stringify(update))
  return data
}

/* API request to checkout mod via api */
export async function checkoutModRequest(gameNameId, modNameId, update) {
  const { data } = await post(
    `/games/${gameNameId}/mods/${modNameId}/checkout`,
    qs.stringify(update)
  )
  return data
}

/* API request to commit the checkout via the api */
export async function checkoutCompleteRequest(update) {
  const { data } = await post('/cogs/checkout/complete', qs.stringify(update))
  return data
}

/* API request to create a buyer's wallet for a game via the api */
export async function getOrCreateBuyerGameWalletRequest() {
  const { data } = await get(`/me/wallets${queryString({ game_id: GAME_ID })}`)
  return data
}

/* API request to get the users payment methods via the monetization api */
export async function getAccountPaymentMethodsRequest() {
  await checkMonTokenTs()
  const { data } = await get(
    `${MONETIZATION_BASE_URL}/accounts/payment-methods`
  )
  return data
}

/* API request to get a game's SKU token packs */
export async function getGameTokenPacksRequest(gameNameId) {
  const { data } = await get(`/games/@${gameNameId}/monetization/token-packs`)
  return data
}

/* API request to get application for Partner Program for a game */
export async function getApplicationForPartnerProgramRequest(gameNameId) {
  const { data } = await get(`/cogs/games/@${gameNameId}/monetization/partners`)
  return data
}
